/**
 * OpenLayers 3 rotate interaction.
 * Allows vector feature rotation.
 *
 * @author Vladimir Vershinin <ghettovoice@gmail.com>
 * @licence MIT https://opensource.org/licenses/MIT
 *          Based on OpenLayers 3. Copyright 2005-2015 OpenLayers Contributors. All rights reserved. http://openlayers.org
 * @copyright (c) 2016, Vladimir Vershinin
 */
import RotateFeatureInteraction from "./RotateFeatureInteraction";

export default RotateFeatureInteraction;



// WEBPACK FOOTER //
// ./src/index.js